import { render, staticRenderFns } from "./PaymentFlexepin.vue?vue&type=template&id=6d20098f&"
import script from "./PaymentFlexepin.vue?vue&type=script&lang=js&"
export * from "./PaymentFlexepin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports